import roundService from '@/services/round.js';

export default {
	debug: false,
	namespaced: true,
	state: {
		rounds: [],
		round: {},
		searchParams: {
			name: '',
			orderBy: '',
			pageSize: 10,
			currentPage: 1
		},
		totalCount: 0,
		totalPages: 0
	},

	mutations: {
		SET_ROUNDS(state, rounds) {
			state.rounds = rounds;
		},
		SET_ROUND(state, round) {
			state.round = round;
		},
		SET_PAGESIZE(state, pageSize) {
			state.searchParams.pageSize = pageSize;
		},
		SET_CURRENTPAGE(state, currentPage) {
			state.searchParams.currentPage = currentPage;
		},
		SET_TOTALPAGES(state, totalPages) {
			state.totalPages = totalPages;
		},
		SET_TOTALCOUNT(state, totalCount) {
			state.totalCount = totalCount;
		},
		SET_MAPID(state, mapId) {
			state.searchParams.mapId = mapId;
		}
	},

	actions: {
		async getRound({ commit }, roundId) {
			return await roundService
				.getRound(roundId)
				.then(data => {
					commit('SET_ROUND', data);
				})
				.catch(err => {
					console.log('Error getting round: ', err);
				});
		},
		async getRounds({ state, commit, dispatch }) {
			dispatch('appStore/setLoading', 1, { root: true });

			return await roundService
				.getRounds(state.searchParams)
				.then(data => {
					const paginationValues = data._pagination;

					if (state.searchParams.currentPage <= paginationValues.totalPages || paginationValues.totalPages == 0) {
						commit('SET_ROUND', data);
						commit('SET_CURRENTPAGE', paginationValues.currentPage);
						commit('SET_TOTALCOUNT', paginationValues.totalCount);
						commit('SET_TOTALPAGES', paginationValues.totalPages);
					} else {
						commit('SET_CURRENTPAGE', paginationValues.totalPages);
						dispatch('getRounds');
					}

					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting rounds: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},
		async createRound({ dispatch }, round) {
			return await roundService
				.createRound(round)
				.then(data => {
					dispatch('getRounds');

					return data;
				})
				.catch(err => {
					console.log('Error creating round: ', err);
				});
		},
		async updateRound({ dispatch }, round) {
			return await roundService
				.updateRound(round)
				.then(() => {
					dispatch('getRounds');
				})
				.catch(err => {
					console.log('Error updating round: ', err);
				});
		},
		async deleteRound({ dispatch }, round) {
			return await roundService
				.deleteRound(round.id)
				.then(() => {
					dispatch('getRounds');
				})
				.catch(err => {
					console.log('Error deleting round: ', err);
				});
		},

		setRound({ commit }, round) {
			commit('SET_ROUND', round);
		},
		setRounds({ commit }, rounds) {
			commit('SET_ROUNDS', rounds);
		},
		setCurrentPage({ commit }, currentPage) {
			commit('SET_CURRENTPAGE', currentPage);
		},
		setPageSize({ commit }, pageSize) {
			commit('SET_PAGESIZE', pageSize);
		},
		setTotalPages({ commit }, totalPages) {
			commit('SET_TOTALPAGES', totalPages);
		},
		setTotalCount({ commit }, totalCount) {
			commit('SET_TOTALCOUNT', totalCount);
		}
	},

	getters: {
		totalPages: state => {
			return state.totalPages;
		},
		totalCount: state => {
			return state.totalCount;
		},
		currentPage: state => {
			return state.searchParams.currentPage;
		},
		pageSize: state => {
			return state.searchParams.pageSize;
		},
		round: state => {
			return state.round;
		},
		rounds: state => {
			return state.rounds;
		},
		pagination: state => {
			return {
				currentPage: state.searchParams.currentPage,
				pageSize: state.searchParams.pageSize,
				totalPages: state.totalPages,
				totalCount: state.totalCount
			};
		}
	}
};
